import axios from 'axios'
import env from '@env'
const { BRANDID } = Config

// 装修API
export default class VoiceAPI {
  /** 获取装修方案信息和广告信息 */
  static async contentMatch (content: string) {
    const url = `${env.VOICE}/content-match/?brandId=${BRANDID}`
    return axios.post(url, { brandId: BRANDID, content }).then((res: any) => {
      return res.result
    })
  }

  static async voiceMatch (params: any) {
    const url = `${env.VOICE}/voice-match/?bo=${window.bo}`
    // const url = `http://192.168.7.74:8080/translate/voice-match/?bo=${window.bo}`
    return axios.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res: any) => {
      return res.result
    })
  }
}
